// frontend/src/components/SiteFooter.js
// Shared marketing-site footer (landing page + /tools/<slug> pages).
import React from 'react';
import { Link } from 'react-router-dom';
import { TOOL_GROUPS } from '../tools';

const SiteFooter = () => (
  <footer className="bg-surface-900 text-surface-300 py-10">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col md:flex-row justify-between gap-8">
        <div>
          <div className="flex items-center space-x-2 mb-3">
            <img src="/assets/kk-logo-wordmark.png" alt="KarbonKit" className="h-6 w-auto brightness-0 invert" />
          </div>
          <p className="text-sm text-surface-400 max-w-md">
            Embeddable tools that help UK households plan their low-carbon transition. Built by <a href="https://www.ucl.ac.uk/" className="text-surface-200 underline hover:text-white transition-colors">UCL</a> researcher Mike Fell. KarbonKit grew out of <a href="https://pumpchic.com" className="text-surface-200 underline hover:text-white transition-colors">pump:chic</a>, a tool designed to let users test drive a heat pump. Please get in touch: <a href="mailto:hello@karbonkit.com" className="text-surface-200 underline hover:text-white transition-colors">hello@karbonkit.com</a>.
          </p>
        </div>

        <div className="flex gap-12 md:gap-16 text-sm">
          <div className="space-y-2">
            <p className="font-medium text-white mb-3">Tools</p>
            {TOOL_GROUPS.flatMap((group) => group.items).map((tool) => (
              <Link key={tool.slug} to={`/tools/${tool.slug}`} className="text-surface-400 hover:text-white transition-colors block">
                {tool.name}
              </Link>
            ))}
          </div>

          <div className="space-y-2">
            <p className="font-medium text-white mb-3">About</p>
            <Link to="/principles" className="text-surface-400 hover:text-white transition-colors block">How we work</Link>
            <Link to="/docs" className="text-surface-400 hover:text-white transition-colors block">Docs</Link>
            <Link to="/methodology" className="text-surface-400 hover:text-white transition-colors block">Methodology</Link>
            <Link to="/privacy" className="text-surface-400 hover:text-white transition-colors block">Privacy &amp; security</Link>
            <a href="https://electrifiedhome.org/" target="_blank" rel="noopener noreferrer" className="text-surface-400 hover:text-white transition-colors block">Demo site</a>
          </div>
        </div>
      </div>

      <div className="border-t border-surface-700 mt-8 pt-6 text-xs text-surface-500">
        &copy; 2025 KarbonKit. All rights reserved.
      </div>
    </div>
  </footer>
);

export default SiteFooter;
